module.exports = __webpack_public_path__ + "img/romanticfraud_question_4_img.21b1346b.jpg";